import React from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import InputField from "components/LoginForm/Input";
import { HashLink as Link } from "react-router-hash-link";

import states from "../Register/registerStatesData";
import businessDescriptions from "../Register/registerBusinessDescriptionsData";
import countries from "../Register/registerCountriesData";

const RegisterIndustryVisitor = (props) => (
  <div className="Register">
    <p htmlFor="reg_years_of_experience" />
    <br />
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder={i18n.translate("loginScreen.fields.email")}
      icon="envelope"
      line
      disabledField={window.location.pathname === "/login/quick-register"}
      required
    />

    {props.passwordField && (
      <InputField
        change={props.change}
        fieldType="password"
        fieldName="reg_password"
        fieldPlaceholder={i18n.translate(
          "loginScreen.version2.fields.passwordRegister"
        )}
        icon="key"
        line
      />
    )}

    {props.passwordField && (
      <InputField
        change={props.change}
        fieldType="password"
        fieldName="reg_passwordConfirm"
        fieldPlaceholder={i18n.translate(
          "loginScreen.version2.fields.passwordConfirm"
        )}
        icon="key"
        line
      />
    )}

    <div className="step space-top">
      {i18n.translate("loginScreen.version2.step3")}
    </div>
    <h5>
      <b>{i18n.translate("loginScreen.version2.step2Sub1")}</b>
    </h5>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate("loginScreen.version2.fields.firstName")}
      icon="user"
      line
      defaultVal={props.userInput.reg_first_name}
      required
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate("loginScreen.version2.fields.lastName")}
      icon="user"
      line
      defaultVal={props.userInput.reg_last_name}
      required
    />

    <p htmlFor="reg_country" className="reg_country">
      {i18n.translate("loginScreen.version2.fields.country")} *
    </p>
    <select
      id="reg_country"
      name="reg_country"
      onChange={props.change}
      value={props.userInput.reg_country}
    >
      <option value="" disabled selected>
        {i18n.translate("loginScreen.version2.fields.select")}
      </option>
      {countries.map((c, index) => {
        const key = index;
        return (
          <option key={key} value={c.code}>
            {c.name}
          </option>
        );
      })}
    </select>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_zip_code"
      fieldPlaceholder={
        props.country === "US"
          ? i18n.translate("loginScreen.version2.fields.zipCode")
          : i18n.translate("loginScreen.version2.fields.postalCode")
      }
      icon="user"
      line
      defaultVal={props.userInput.reg_zip_code}
      required
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_city"
      fieldPlaceholder={i18n.translate("loginScreen.version2.fields.city")}
      icon="user"
      line
      defaultVal={props.userInput.reg_city}
      required
    />

    {props.country !== "US" && (
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_state"
        fieldPlaceholder={i18n.translate(
          "loginScreen.version2.fields.province"
        )}
        icon="map"
        line
        defaultVal={props.userInput.reg_state}
        required
      />
    )}

    {props.country === "US" && (
      <React.Fragment>
        <p htmlFor="reg_state" className="reg_state">
          {i18n.translate("loginScreen.version2.fields.state")} *
        </p>
        <select
          id="reg_state"
          name="reg_state"
          onChange={props.change}
          value={props.userInput.state}
        >
          <option value="" disabled selected>
            {i18n.translate("loginScreen.version2.fields.select")}
          </option>
          {states.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.value}>
                {c.label}
              </option>
            );
          })}
        </select>
      </React.Fragment>
    )}

    <h5 style={{ marginTop: "5rem" }}>
      <b>{i18n.translate("loginScreen.version2.step2Sub2")}</b>
    </h5>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder={i18n.translate("loginScreen.version2.fields.company")}
      icon="home"
      line
      defaultVal={props.userInput.reg_agency_name}
      required
    />

    <p htmlFor="reg_title" className="reg_title">
      {i18n.translate("loginScreen.version2.fields.title")} *
    </p>
    <select
      id="reg_title"
      name="reg_title"
      onChange={props.change}
      value={props.userInput.reg_title}
    >
      <option value="" disabled selected>
        {i18n.translate("loginScreen.version2.fields.select")}
      </option>
      <option value="Executive">
        {i18n.translate("loginScreen.version2.fields.executive")}
      </option>
      <option value="Management">
        {i18n.translate("loginScreen.version2.fields.management")}
      </option>
      <option value="Marketing">
        {i18n.translate("loginScreen.version2.fields.marketing")}
      </option>
      <option value="Sales">
        {i18n.translate("loginScreen.version2.fields.sales")}
      </option>
      <option value="Coordinator">
        {i18n.translate("loginScreen.version2.fields.coordinator")}
      </option>
      <option value="Other">
        {i18n.translate("loginScreen.version2.fields.other")}
      </option>
    </select>

    {props.country == "US" && (
      <React.Fragment>
        <p htmlFor="reg_host_agency_name" className="reg_host_agency_name">
          {i18n.translate("loginScreen.version2.fields.description")} *
        </p>
        <select
          id="reg_host_agency_name"
          name="reg_host_agency_name"
          onChange={props.change}
          value={props.userInput.reg_host_agency_name}
        >
          <option value="" disabled selected>
            {i18n.translate("loginScreen.version2.fields.select")}
          </option>
          {businessDescriptions.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.value}>
                {c.label}
              </option>
            );
          })}
        </select>
      </React.Fragment>
    )}

    <div className="privacy">
      <b>{i18n.translate("loginScreen.version2.privacyHead")}</b>
      <br />
      {i18n.translate("loginScreen.version2.privacySub")}
      <br />
      <b>{i18n.translate("loginScreen.version2.privacy")}</b>
    </div>

    <span className="checkItem">
      <InputField
        change={props.change}
        fieldLabel={i18n.translate("loginScreen.version2.fields.opt")}
        fieldName="opt_in_marketing"
        fieldType="checkbox"
        icon="envelope"
        line={false}
        title={i18n.translate("loginScreen.fields.opt")}
        checked={props.userInput.opt_in_marketing}
        required={false}
        userSelect={false}
        key={props.userInput.opt_in_marketing}
      />
    </span>

    <span className="checkItem">
      <InputField
        change={props.change}
        fieldLabel={i18n.translate("loginScreen.version2.fields.optMarketing")}
        fieldName="marketing_opt_in"
        fieldType="checkbox"
        icon="envelope"
        line={false}
        title={i18n.translate("loginScreen.version2.fields.optMarketing")}
        checked={props.userInput.marketing_opt_in}
        required={false}
        userSelect={false}
        key={props.userInput.marketing_opt_in}
      />
    </span>

    <div className="login__form--buttons">
      {window.location.pathname.includes("/register-mobile") &&
        window.location.pathname.includes("/login/register-mobile") &&
        window.location.pathname.includes("/login/quick-register-mobile") && (
          <style>
            {" "}
            {
              "\
              #openWidget { display: none; bottom: 3rem; } #logoHeader { display: none; } .cookieConsent { display: none !important; } .loginView__content--logo { display: none !important; }"
            }
          </style>
        )}
      {window.location.pathname !== "/register-mobile" &&
        window.location.pathname !== "/login/register-mobile" &&
        window.location.pathname !== "/login/quick-register-mobile" && (
          <Link to="/login">
            <button
              type="button"
              onClick={props.back}
              className="Email__input--button btnInverse"
            >
              {i18n.translate("general.back")}
            </button>
          </Link>
        )}
      <button
        type="submit"
        onClick={props.submit}
        className="Email__input--button"
      >
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
          </span>
        ) : (
          i18n.translate("loginScreen.register")
        )}
      </button>
    </div>
  </div>
);

export default RegisterIndustryVisitor;

RegisterIndustryVisitor.propTypes = {
  defaultVal: PropTypes.string,
  country: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
  passwordField: PropTypes.bool.isRequired,
  userInput: PropTypes.shape({
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_country: PropTypes.string,
    reg_city: PropTypes.string,
    reg_state: PropTypes.string,
    reg_agency_affiliation: PropTypes.string,
    reg_host_agency_name: PropTypes.string,
    reg_zip_code: PropTypes.string,
    reg_title: PropTypes.string,
    marketing_opt_in: PropTypes.bool,
    opt_in_marketing: PropTypes.bool,
  }),
};

RegisterIndustryVisitor.defaultProps = {
  defaultVal: "",
  userInput: {
    reg_email: "",
    reg_first_name: "",
    reg_last_name: "",
    reg_agency_name: "",
    reg_country: "",
    reg_city: "",
    reg_state: "",
    reg_agency_affiliation: "",
    reg_host_agency_name: "",
    reg_zip_code: "",
    reg_title: "",
    marketing_opt_in: false,
    opt_in_marketing: false,
  },
};
